export default {
  notFound: {
    seo: { title: 'Página no encontrada' },
    badge: 'Error 404',
    title: 'Te has salido de la ruta',
    description:
      'La URL solicitada no está en nuestro mapa. Comprueba la dirección, vuelve al inicio o contáctanos si necesitas ayuda.',
    requestedPathLabel: 'Ruta solicitada',
    backHome: 'Volver al inicio',
    contactUs: 'Contáctanos',
    pricing: 'Precios',
    tagline: 'Geofleet · Última milla y operaciones de flota',
  },
};
